// eslint-disable-next-line prettier/prettier
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

// const router = new VueRouter({
//   mode: 'hash',
//   base: process.env.BASE_URL,
//   routes
// });

const routes = [
  {
    path: "/prueba",
    name: "Prueba",
    component: () => import("../modulos/Prueba/Prueba.vue"),
  },
  {
    path: "/bobinas",
    name: "bobinas",
    component: () =>
      import("../modulos/Materiales/componentes/modalBobinas.vue"),
  },

  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/About.vue"),
  },
  {
    path: "/Principal",
    name: "Menú Principal",
    component: () => import("../views/Principal.vue"),
  },
  {
    path: "/AgregarTareaUsuario",
    name: "Asignar Tarea a Usuario",
    component: () => import("../views/AgregarTareaUsuario.vue"),
  },
  {
    path: "/AsignarRolUsuario",
    name: "Asignar Rol a Usuario",
    component: () => import("../views/AsignarRolUsuario.vue"),
  },
  {
    path: "/AgregarUsuario",
    name: "Agregar Usuario",
    component: () => import("../views/AgregarUsuario.vue"),
  },
  {
    path: "/AsignarTareaCuadrilla",
    name: "Asignar Tarea a Cuadrilla",
    component: () => import("../views/AsignarTareaCuadrilla.vue"),
  },
  {
    path: "/ListadoTareasAsignadas",
    name: "Listado Tareas Asignadas",
    component: () => import("../views/ListadoTareasAsignadas.vue"),
  },
  {
    path: "/Cuadrillas",
    name: "Cuadrilla",
    component: () => import("../modulos/Cuadrilla/Cuadrillas.vue"),
  },
  {
    path: "/Tareas",
    name: "Tareas",
    component: () => import("../modulos/Tareas/Tareas.vue"),
  },
  {
    path: "/Materiales",
    name: "Materiales",
    component: () => import("../modulos/Materiales/Materiales.vue"),
  },
  {
    path: "/Reportes",
    name: "Reportes",
    component: () => import("../modulos/Reportes/Reportes.vue"),
  },
  {
    path: "/TareasCuadrillas",
    name: "TareasCuadrillas",
    component: () =>
      import("../modulos/Tareas/componentes/modalTareasCuadrilla.vue"),
  },
  {
    path: "/Contratistas",
    name: "Contratistas",
    component: () => import("../modulos/Contratista/Contratistas.vue"),
  },
  {
    path: "/Cajones",
    name: "Cajones",
    component: () => import("../modulos/Cajones/Cajones.vue"),
  },
  {
    path: "/ArmarCajon",
    name: "ArmarCajon",
    component: () =>
      import("../modulos/Materiales/componentes/modalMateriales.vue"),
  },
  {
    path: "/ot",
    name: "ot",
    component: () => import("../modulos/OT/OT.vue"),
  },
  {
    path: "/inspeccionarTarea",
    name: "inspeccionarTarea",
    component: () =>
      import("../modulos/Tareas/componentes/modalInspeccionarTarea.vue"),
  },

  {
    path: "/Usuarios",
    name: "usuarios",
    component: () => import("../modulos/Usuarios/Usuarios.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  //mode: "hash",
  base: process.env.BASE_URL,
  //base: '/sctareas/',
  routes,
});

export default router;
